// service container for local storage, indexdb and all things client persisted state that doesn't come from Firebase backend DBs
class ClientStorageService {
  static getCurrentHunt() {
    return JSON.parse(localStorage.getItem("currentHunt")!);
  }

  static setCurrentHunt(hunt) {
    localStorage.setItem("currentHunt", JSON.stringify(hunt));
  }

  static getCurrentChallengeLevel(): number {
    const level = localStorage.getItem("currentChallengeLevel");
    if (!level) return 0;
    return parseInt(level)
  }

  static setCurrentChallengeLevel(level: number) {
    return localStorage.setItem("currentChallengeLevel", level.toString());
  }

  static setHuntActivationDateTime() {
    localStorage.setItem("huntActivationDate", JSON.stringify(new Date()));
  }

  static getHuntActivationDateTime() {
    return localStorage.getItem("huntActivationDate");
  }

  static clearHuntCache() {
    console.info('clearing hunt cache items')
    const hunt = ClientStorageService.getCurrentHunt();
    if (hunt?.id) localStorage.removeItem(`ht_v1_timer_${hunt.id}`);
    localStorage.removeItem("huntActivationDate");
    localStorage.removeItem("currentHunt");
    localStorage.removeItem("currentChallengeLevel");
  }

  static setLanguageCode(code: string) {
    localStorage.setItem("language", code);
  }

  static getLanguageCode(): string {
    return localStorage.getItem('language') || ''
  }

  // Separate key for Maps API language so the router's i18n writes don't interfere.
  static setMapsLanguage(code: string) {
    localStorage.setItem("mapsLanguage", code);
  }

  static getMapsLanguage(): string {
    return localStorage.getItem('mapsLanguage') || '';
  }
}

export default ClientStorageService;
